import { 
    Card, 
    Link, 
    Container,
    Alert,
    Text, 
    VStack,
} from "@postenbring/hedwig-react"
import './fasttrack.scss'

export const FastTrack = ({ pages = [], editMode = false, errorMessage = "" }) => (
    <section className="fasttrack-section">
        {editMode && errorMessage && (
            <Alert variant="error">
                <Alert.Title>Error</Alert.Title>
                <Alert.Description>{errorMessage}</Alert.Description>
            </Alert>
        )}
        {pages.map(page => (
            <div
                className="fasttrack-container"
                key={page.id || page.name}
                data-name={page.name}
                data-belongs-to={page.belongsTo}
                data-href={page.href}
                style={{ viewTransitionName: "fasttrackswish" }}
            >
                <Container>
                    <VStack gap="24-32">
                        <Text variant="h1">
                            {page.title}
                        </Text>
                        {page.preface && (
                            <Text variant="h2">
                                {page.preface}
                            </Text>
                        )}
                        <div className="fasttrack-grid">
                            {page.boxes && page.boxes.map((box, i) => (
                                <Card
                                    variant="miniature"
                                    color="lighter-brand"
                                    key={box.title + i}
                                >
                                    <Card.Body>
                                        <Card.BodyHeader as="h2">
                                            <Card.BodyHeaderTitle>{box.title}</Card.BodyHeaderTitle>
                                        </Card.BodyHeader>
                                        <Card.BodyAction asChild>
                                            <Link 
                                                href={box.href} 
                                                variant="no-underline" 
                                                size="small"
                                                target={box.newTab ? "_blank" : undefined}
                                                rel={box.newTab ? "noopener noreferrer" : undefined}
                                            >
                                                {box.text}
                                            </Link>
                                        </Card.BodyAction>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </VStack>
                </Container>
            </div>
        ))}
    </section>
)
